import React, { useEffect, useState, useRef } from 'react';
import GeneralSwiper from './GeneralSwiper';
import GridLoadingSkeleton from '../skeletons/GridLoadingSkeleton';
import CustomCard from '../card/Card';
var _ = require('lodash');

const SwipableList = (props) => {





    return (
        <>
            {(props.allData || props.favouritesData) == null ?
                <GridLoadingSkeleton
                    variant={"rectangular"}
                    marginx={1} 
                    marginy={1}
                    rows={1}
                    count={window.innerWidth < 720 ? 2 : 4}
                    height={"15rem"}
                    width={"15rem"} />
                :
                <GeneralSwiper
                    component={CustomCard}
                    idColumn={"id"}
                    sortKey={"visitTime"}
                    {...props}
                />
            }
        </>
    )
}

export default SwipableList
